module.exports = __webpack_public_path__ + "img/popup-btn-guest.0b15afd.png";